import type { FromWhere } from './declare'
import type { FilterGroup } from 'src/utils/common'
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { Tabs } from 'antd'
import { FormPage } from 'src/components'
import { appStore } from 'src/stores'
import { api, $api, $consts, $evt } from 'src/plugins'
import { checkCondition, getCustomParamsFromNav_Tables } from './helper'
import { initFilter } from 'src/utils/common'
import { flatten } from 'flat'
import { get, set } from 'lodash'
import 'src/styles/components/root/combinationPage.less'

type FormData = {
  // 表单本身配置的 formId
  formId?: string,
  // 从哪个页面具体被调用
  fromWhere?: FromWhere,
  // 查询参数
  filterGroup?: FilterGroup,
}

type Props = {
  formCode: string,
  formData?: FormData
}

const CombinationPropsContext = React.createContext<Props>({ formCode: '' })
const CombinationContext = React.createContext<any>(undefined)
const CombinationPage = (props: Props) => {
  const [formState, setFormState] = useState<any>()

  const initPayload = useRef({})
  const prevPayload = useRef({})
  useEffect(() => {
    const { OrgId } = appStore.current.headers
    const payload = initFilter({ OrgId, Keyword: props.formCode })
    $api['table/getTablePageTables'](payload).then((res: any) => {
      if (res) {
        setFormState(res)
        const queryParams = getCustomParamsFromNav_Tables(res.Nav_Tables)
        if (queryParams) {
          const payload = { commonPayload: queryParams }
          const flat = flatten(payload)
          Object.keys(flat!).forEach(key => {
            const initVal = get(api.requestParams, key)
            initVal !== undefined && set(initPayload.current, key, initVal)
          })
          prevPayload.current = flat!
          api.setRequestParams(payload)
        }
      }
    })
  }, [props.formCode])

  const handleChange = (key: string) => {
    const findIndex = formState.Nav_Tables.findIndex((item: any) => item.ID === key)
    const queryParams = getCustomParamsFromNav_Tables(formState.Nav_Tables, findIndex)
    if (queryParams) {
      const payload = { commonPayload: queryParams }
      const flat = flatten(payload)
      Object.keys(prevPayload.current).forEach(key => {
        api.unsetRequestParams(key)
      })
      prevPayload.current = flat!
      api.setRequestParams(payload)
    }
    $evt.emit($consts['EVT/COMBINATION_PAGE_TABCHANGE'], key)
  }

  useEffect(() => {
    return () => {
      Object.keys(prevPayload.current).forEach(key => {
        api.unsetRequestParams(key)
      })
      api.setRequestParams(initPayload.current)
    }
  }, [])

  const items = useMemo(() => {
    if (!formState?.Nav_Tables) return []

    const pages: any[] = []
    formState.Nav_Tables.forEach((item: any) => {
      const isShow = checkCondition(item.TABLE_CONDITION, undefined, appStore.current.activeMenu.MENU_FORM_PARAMS)
      isShow && pages.push({
        key: item.ID,
        label: item.LABEL_NAME,
        children: <FormPage formCode={item.CODE} formData={{ parentFormId: item.ID, ...props.formData }} />
      })
    })
    return pages
  }, [formState?.Nav_Tables])

  return (
    <CombinationPropsContext.Provider value={props}>
      <CombinationContext.Provider value={formState}>
        <div className='combination-page'>
          <Tabs size='small' items={items} onChange={handleChange} />
        </div>
      </CombinationContext.Provider>
    </CombinationPropsContext.Provider>
  )
}

export { CombinationPropsContext, CombinationContext }
export default CombinationPage